import { Flex } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SymbolBox } from 'src/components/common/SymbolBox/symbolBox';
import { trimText } from 'src/utils/utils';

interface IGameMiniHeader {
	title: string;
	colorHex: string;
	symbol: string;
}

export const GameMiniHeader: FC<IGameMiniHeader> = ({ title, colorHex, symbol }) => {
	const { t } = useTranslation();

	return (
		<Flex
			fontSize="16px"
			fontWeight="bold"
			gridGap="10px"
			align="center"
		>
			{title !== '' ? trimText(title, 25, true) : t('form.fields.gameName')}
			<SymbolBox
				colorHex={colorHex}
				abbreviation={symbol}
			/>
		</Flex>
	);
};
